/* eslint-disable eqeqeq */
import { useEffect, useState } from 'react';
import { usePositionService, PositionType, SOFTWARE_ENGINEER_ID } from 'domain/shared/employee';
import { useTechnologyService, type Technology } from 'domain/shared/career';
import { TextField, useFieldHelper } from 'framework/ui/field';

const ProjectTeamSlotPositionField = ({
  positionIdSource = 'positionId',
  technologyIdSource = 'technologyId',
  competencyLevelSource = 'competencyLevel',
  descriptionSource = 'description',
}: {
  positionIdSource?: string;
  technologyIdSource?: string;
  competencyLevelSource?: string;
  descriptionSource?: string;
}) => {
  const { findAll: getAllPositions } = usePositionService();
  const { findAll: getAllTechnologies } = useTechnologyService();

  const [positions, setPositions] = useState<Nullable<PositionType[]>>(null);
  const [technologies, setTechnologies] = useState<Nullable<Technology[]>>(null);

  const { getValue: getPosition } = useFieldHelper<number>({ source: positionIdSource });
  const { getValue: getTechnology } = useFieldHelper({ source: technologyIdSource });
  const { getValue: getCompetencyLevel } = useFieldHelper({ source: competencyLevelSource });
  const { getValue: getDescription } = useFieldHelper<string>({ source: descriptionSource });

  const position = getPosition();
  const technology = getTechnology();
  const competencyLevel = getCompetencyLevel();
  const description = getDescription();

  useEffect(() => {
    (async () => {
      const positionsRezult = await getAllPositions();
      const technologiessRezult = await getAllTechnologies();

      setPositions(positionsRezult);
      setTechnologies(technologiessRezult);
    })();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const renderValue = () => {
    if (!position && description) {
      return description;
    }

    const currentPosition = positions?.find(item => item.id == position);
    const currentTechnology = technologies?.find(item => item.id == technology);

    return `${currentTechnology?.name || ''} ${position == SOFTWARE_ENGINEER_ID ? 'engineer' : currentPosition?.name} ${competencyLevel ? `(${competencyLevel})` : ''}`;
  };

  return <TextField value={<span style={{ fontWeight: 500 }}>{renderValue()}</span>} />;
};

export default ProjectTeamSlotPositionField;
